import { call, put, takeEvery, all, fork, takeLatest } from "redux-saga/effects";

// Crypto Redux States
import {
  FETCH_EMPLOYEE_DASHBOARD_FAILURE,
  FETCH_EMPLOYEE_DASHBOARD_REQUEST,
  FETCH_EMPLOYEE_DASHBOARD_SUCCESS,
  FETCH_HOD_DASHBOARD_FAILURE,
  FETCH_HOD_DASHBOARD_REQUEST,
  FETCH_HOD_DASHBOARD_SUCCESS,
  FETCH_HR_DASHBOARD_FAILURE,
  FETCH_HR_DASHBOARD_REQUEST,
  FETCH_HR_DASHBOARD_SUCCESS,
  FETCH_ORG_CHART_FAILURE,
  FETCH_ORG_CHART_REQUEST,
  FETCH_ORG_CHART_SUCCESS,
  GET_CHARTS_DATA,
  SEND_BIRTHDAY_WISHES_FAILURE,
  SEND_BIRTHDAY_WISHES_REQUEST,
  SEND_BIRTHDAY_WISHES_SUCCESS,
  FETCH_HOD_DASHBOARDPROJECTVIEW_REQUEST,
  FETCH_HOD_DASHBOARDPROJECTVIEW_SUCCESS,
  FETCH_HOD_DASHBOARDPROJECTVIEW_FAILURE,
  FETCH_HR_DASHBOARDPROJECTVIEW_REQUEST,
  FETCH_HR_DASHBOARDPROJECTVIEW_SUCCESS,
  FETCH_HR_DASHBOARDPROJECTVIEW_FAILURE
} from "./actionTypes";
import { apiSuccess, apiFail } from "./actions";

//Include Both Helper File with needed methods
import {
  getWeeklyData,
  getYearlyData,
  getMonthlyData,
}
  from "../../helpers/fakebackend_helper";
import Swal from "sweetalert2";
import { post } from "helpers/api_helper";

function* getChartsData({ payload: periodType }) {
  try {
    var response;
    if (periodType == "monthly") {
      response = yield call(getWeeklyData, periodType);
    }
    if (periodType == "yearly") {
      response = yield call(getYearlyData, periodType);
    }
    if (periodType == "weekly") {
      response = yield call(getMonthlyData, periodType);
    }

    yield put(apiSuccess(GET_CHARTS_DATA, response));
  } catch (error) {
    yield put(apiFail(GET_CHARTS_DATA, error));
  }
}


function* fetchEmployeeDashboardSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEEDASHBOARD, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch employee dashboard!");
    }

    yield put({ type: FETCH_EMPLOYEE_DASHBOARD_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: FETCH_EMPLOYEE_DASHBOARD_FAILURE, payload: error });
  }
}

function* sendBirthdayWishesSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SEND_BIRTHDAY_WISHES, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to send birthday wishes!");
    }

    yield put({ type: SEND_BIRTHDAY_WISHES_SUCCESS, payload: response });

    Swal.fire({
      title: "🎉 Wishes Sent!",
      text: response?.message || "Your birthday wishes were sent successfully!",
      icon: "success",
      confirmButtonColor: "#3085d6",
    });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: SEND_BIRTHDAY_WISHES_FAILURE, payload: error });
  }
}

function* fetchHRDashboardSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_HR_DASHBOARD, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch HR dashboard!");
    }

    yield put({ type: FETCH_HR_DASHBOARD_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: FETCH_HR_DASHBOARD_FAILURE, payload: error });
  }
}

function* fetchHODDashboardSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_HOD_DASHBOARD, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch HOD dashboard!");
    }

    yield put({ type: FETCH_HOD_DASHBOARD_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: FETCH_HOD_DASHBOARD_FAILURE, payload: error });
  }
}

function* fetchOrgChartSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_ORG_CHART, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch organization chart!");
    }

    yield put({ type: FETCH_ORG_CHART_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: FETCH_ORG_CHART_FAILURE, payload: error });
  }
}

function* fetchHODDashboardProjectviewSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_HOD_DASHBOARD_PROJECTVIEW, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch HOD dashboard project view!");
    }

    yield put({ type: FETCH_HOD_DASHBOARDPROJECTVIEW_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: FETCH_HOD_DASHBOARDPROJECTVIEW_FAILURE, payload: error });
  }
}

function* fetchHRDashboardProjectviewSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_HR_DASHBOARD_PROJECTVIEW, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch HOD dashboard project view!");
    }

    yield put({ type: FETCH_HR_DASHBOARDPROJECTVIEW_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: FETCH_HR_DASHBOARDPROJECTVIEW_FAILURE, payload: error });
  }
}

export function* watchGetChartsData() {
  yield takeEvery(GET_CHARTS_DATA, getChartsData);
  yield takeLatest(FETCH_EMPLOYEE_DASHBOARD_REQUEST, fetchEmployeeDashboardSaga);
  yield takeLatest(SEND_BIRTHDAY_WISHES_REQUEST, sendBirthdayWishesSaga);
  yield takeLatest(FETCH_HR_DASHBOARD_REQUEST, fetchHRDashboardSaga);
  yield takeLatest(FETCH_HOD_DASHBOARD_REQUEST, fetchHODDashboardSaga);
  yield takeLatest(FETCH_ORG_CHART_REQUEST, fetchOrgChartSaga);
  yield takeLatest(FETCH_HOD_DASHBOARDPROJECTVIEW_REQUEST, fetchHODDashboardProjectviewSaga);
  yield takeLatest(FETCH_HR_DASHBOARDPROJECTVIEW_REQUEST, fetchHRDashboardProjectviewSaga);

}

function* dashboardSaga() {
  yield all([fork(watchGetChartsData)]);
}

export default dashboardSaga;
